import React from 'react';

export const Help = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17 7c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10S22.523 7 17 7zm0 18.182a8.182 8.182 0 1 1 0-16.364 8.182 8.182 0 0 1 0 16.364zm-1.027-5.296h2.054v2.054h-2.054v-2.054zm3.064-7.064a3.077 3.077 0 0 0-2.037-.732 3.092 3.092 0 0 0-3.054 2.595h-1.948c.058-1.243.594-2.413 1.495-3.252a4.97 4.97 0 0 1 3.507-1.342c1.308 0 2.561.488 3.479 1.341a4.41 4.41 0 0 1 1.476 3.254 4.05 4.05 0 0 1-1.058 2.713c-.62.674-1.42 1.139-2.227 1.473-.493.196-.823.45-1.018.701-.192.247-.252.501-.252.766h-1.948c0-.764.21-1.504.687-2.111.476-.604 1.156-1.018 1.806-1.276.591-.246 1.057-.508 1.358-.836a1.94 1.94 0 0 0 .502-1.336c0-.624-.262-1.196-.768-1.658z"
      />
    </svg>
  );
};

export default Help;
